import * as React from 'react';
import accounting from 'accounting';
import VisibilitySensor from 'react-visibility-sensor';
import {
  ifLoggedIn,
  goToPartDetail,
  partDetailUrl
} from 'src/utils/navigation';

import Button from 'src/components/common/Button';

import ProductModel from 'src/model/product.model';
import env from 'src/shared/env';
import './PartCard.scss';
import { isVisible } from 'src/utils/componentVisibility';
import { highlightText } from 'src/utils/styleFunctions';
// import { env } from 'process';

interface IPartCardProps {
  ref: any;
  part: ProductModel;
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  image: string;
  dataOnVisible: boolean;
  showGoToDiagram: boolean;
  goToDiagram(diagramId: number): any;
  t?(key: string): any;
  partUpdate?(
    partId: string,
    manufacturerCode: string,
    ownerDiagram: number
  ): void;
  setActivePart(): void;
  handleToggleFavorite?(
    name: string,
    mfc: string,
    ownerDiagram: number,
    favorite: boolean,
    favoriteId: number,
    featured: boolean
  ): void;
  textFilter: string;
  modelDiagramProductClick(data: any): void;
  position: number;
}

class PartCard extends React.Component<IPartCardProps, any> {
  private ref: HTMLElement;

  // public componentDidUpdate() {
  //   const { props } = this;

  //   this.updateProduct(isVisible(this.ref), props);
  // }

  /* 
    getStatus
   */
  private getStatus = (): {
    available: boolean;
  } => {
    const { part } = this.props;
    const availableFlag = {
      available: part.available,
      notLongerAvailable: false
    };

    return availableFlag;
  };

  /* 
    getStatusText
   */
  private getStatusText = () => {
    const { t, part } = this.props;
    const availableFlag = this.getStatus();
    if (availableFlag.available) {
      if (part.inStock) {
        return part.state;
      } else {
        return part.state;
      }
    } else {
      return t('common.contactUsForAvailability');
    }
  };

  private renderStatus = (t: any) => {
    const { part } = this.props;
    const { productDetailsState } = part;

    if (
      productDetailsState === 'loading' ||
      productDetailsState === 'pending'
    ) {
      return (
        <div className="rp-part-card--status-container">
          <span className="loading-bar" />
        </div>
      );
    } else if (productDetailsState === 'none') {
      return (
        <div className="rp-product-card--status">
          <div className="rp-part-card--status-container">
            <i className={`rpds-error not-available`} />
            <p className="stock-label">
              {t('common.contactUsForAvailability')}
            </p>
          </div>
          {part.specialOrder && (
            <div className="rp-part-card--status-container">
              <i className={`rpds rpds-new-releases special-order`} />
              <p className="stock-label">Special Order</p>
            </div>
          )}
        </div>
      );
    } else if (part !== null) {
      if (part.inStock != null && this.props.isLoggedIn) {
        const inStockText = this.getStatusText();
        const availableFlag = this.getStatus();

        const inStockClass = (): string => {
          if (part.inStock) {
            return 'rpds-check-circle in-stock';
          } else if (part.specialOrder) {
            return 'rpds-error out-of-stock';
          } else if (availableFlag.available && part.state === 'Backorder') {
            return 'rpds-remove-circle out-of-stock';
          } else if (
            availableFlag.available &&
            part.state === 'No Longer Available'
          ) {
            return 'rpds-close no-longer-available';
          } else {
            return 'rpds-error not-available';
          }
        };

        return (
          <div className="rp-product-card--status">
            <div className="rp-part-card--status-container">
              <i
                title={part.stateDescription}
                className={`${inStockClass()}`}
              />
              <p title={part.stateDescription} className="stock-label">
                {inStockText}
              </p>
            </div>
          </div>
        );
      } else {
        return <React.Fragment />;
      }
    }
    return <React.Fragment />;
  };

  private goToProduct = () => {
    const productClicked = this.props.part;
    productClicked['position'] = this.props.position + 1;
    this.props.modelDiagramProductClick({ product: productClicked });
    ifLoggedIn(() =>
      goToPartDetail(
        this.props.part.replacedPart
          ? `${
              this.props.part.manufacturerCode
                ? this.props.part.manufacturerCode + '  '
                : ''
            }${this.props.part.productNumber}`
          : `${
              this.props.part.manufacturerCode
                ? this.props.part.manufacturerCode + '  '
                : ''
            }${this.props.part.productNumber}`
      )
    );
  };

  private renderModelDescription = (t: any) => {
    const { part } = this.props;
    const { productDetailsState } = part;

    const partDescription = part.description
      ? part.description.toLowerCase()
      : '';

    if (
      productDetailsState === 'loading' ||
      productDetailsState === 'pending'
    ) {
      return <></>;
    } 
    else  if (part) {
      return (<dl
      className="data--description"
      dangerouslySetInnerHTML={{
        __html: highlightText(
        partDescription,
        this.props.textFilter,
        'rp-highlight-background'
        )
      }}/>)
    }
    return <React.Fragment />;
  };

  private renderPrices = (t: any) => {
    const { part } = this.props;
    const { productDetailsState } = part;
    const availableFlag = this.getStatus();

    if (
      productDetailsState === 'loading' ||
      productDetailsState === 'pending'
    ) {
      return (
        <div className="rp-part-card--info-prices">
          <div className="price">
            <span className="loading-bar" />
          </div>
          <div className="msrp">
            <span className="loading-bar" />
          </div>
        </div>
      );
    } 
    
    else if (productDetailsState === 'none' || !availableFlag.available) {
      return <React.Fragment />;
    } else if (part != null) {
      return this.props.isLoggedIn ? (
        <>
        <div className="rp-part-card--info-prices">
          {!this.props.showOnlyMSRP && (
            <div className="price">
              <span className="label">{t('common.price')}</span>
              <p className="number">
                {accounting.formatMoney(part.partnerPrice)}
              </p>
            </div>
          )}
          <div className="msrp">
            <span className="label">{t('common.msrp')}</span>
            <p className="number">{accounting.formatMoney(part.retailPrice)}</p>
          </div>
        </div>
        {part.extraCharges > 0 && part.hasExtraCharges === true && (        
        <div className="rp-part-details-desktop--info--extra">
          <div><span className="rpds-error stock-error-icon"/>
          <span className="rp-part-details-desktop--info--extra-title">{t('common.additionalFeeApply')} </span></div>
          <p className="rp-part-details-desktop--info--extra-text">{t('common.extraCharge')} {accounting.formatMoney(part.extraCharges)} {t('common.applyAtCheckout')}</p>
          </div>) 
          }</>
      ) : (
        <div className="rp-part-card--info-login">
          {t('common.loginToViewPrices')}
        </div>
      );
    }
    return <React.Fragment />;
  };

  private renderButtons = (t: any) => {
    const availableFlag = this.getStatus();

    if (
      this.props.part.isAvailable &&
      this.props.part.state !== 'No Longer Available' &&
      this.props.isLoggedIn &&
      availableFlag.available
    ) {
      if (
        this.props.part.productDetailsState !== 'loading' &&
        this.props.part.productDetailsState !== 'none'
      ) {
        if (
          availableFlag.available &&
          this.props.part.state !== 'No Longer Available'
        ) {
          return (
            <React.Fragment>
              <Button
                buttonClass="primary-button button-text-no-wrap"
                textTransform="uppercase"
                width="50%"
                label={t('common.buyNow')}
                action={() => {
                  this.goToProduct();
                }}
              />
            </React.Fragment>
          );
        } else {
          return <React.Fragment />;
        }
      } else {
        return <React.Fragment />;
      }
    } else {
      return <React.Fragment />;
    }
  };

  private updateProduct = (visible: boolean, props: IPartCardProps) => {
    if (
      visible &&
      props.dataOnVisible &&
      props.part.productDetailsState === 'pending'
    ) {
      props.partUpdate(
        props.part.productNumber,
        props.part.manufacturerCode,
        props.part.diagramOwner
      );
    }
  };

  private renderContent = () => {
    const { props } = this;
    const { t, part } = props;

    const partDescription = part.description
      ? part.description.toLowerCase()
      : '';

    const partNumber = part.productNumber;

    const partSeries = part.partSeries ? part.partSeries : null;

    const isFavorite = part.favorite;

    const favoriteId = part.idFavoriteItem;

    const isDeal = part.discountInfo;

    const notAvailableClass = part.isAvailable ? '' : 'no-data';

    const notLoggedClass = props.isLoggedIn ? '' : 'no-data';

    const handleToggleFavorite =
      this.props.handleToggleFavorite || (() => console.log('toggle'));

    const completeTitle = partNumber + (partSeries ? ` (${partSeries})` : '');

    const Replacedpart = part.replacedPart ? 'Rpl: ' + part.replacedPart : '';

    return (
      <div
        className={`rp-part-card ${notAvailableClass} ${notLoggedClass}`}
        ref={(ref: HTMLElement) => (this.ref = ref)}
      >
        <div className="rp-part-card--data-container">
          <div className="rp-part-card--image">
            {part.available &&
              part.state !== 'NLA' &&
              this.props.isLoggedIn &&
              (isFavorite ? (
                <span
                  className="favorite rpds rpds-star yellow"
                  onClick={e =>
                    handleToggleFavorite(
                      part.productNumber,
                      part.manufacturerCode,
                      part.diagramOwner,
                      isFavorite,
                      favoriteId,
                      part.featured ? part.featured : false
                    )
                  }
                />
              ) : (
                <span
                  className="favorite rpds rpds-star-border"
                  onClick={e =>
                    handleToggleFavorite(
                      part.productNumber,
                      part.manufacturerCode,
                      part.diagramOwner,
                      isFavorite,
                      favoriteId,
                      part.featured ? part.featured : false
                    )
                  }
                />
              ))}
            <span
              className={
                'image ' +
                (part.state === 'No Longer Available' || !part.available
                  ? 'no-image-pointer'
                  : '')
              }
              style={{
                backgroundImage: `url(${props.image})`
              }}
              onClick={() =>
                part.state !== 'No Longer Available' ? this.goToProduct() : ''
              }
            >
              <span className={`identifierMobile`}>
                {part.diagramReferenceNumber
                  ? part.diagramReferenceNumber
                  : 'N/A'}
              </span>
            </span>
            {this.props.showGoToDiagram && part.diagramOwner && (
              <div
                className="rp-part-card--diagram-link"
                onClick={e => this.props.goToDiagram(part.diagramOwner)}
              >
                Go to diagram
              </div>
            )}
          </div>
          <div className="rp-part-card--data">
            <div className="data-container">
              <div className="data--title-deal">
                <h1
                  className={
                    'data--title ' +
                    (part.state === 'No Longer Available' || !part.available
                      ? 'no-image-pointer'
                      : '')
                  }
                  onClick={() =>
                    part.state !== 'No Longer Available'
                      ? this.goToProduct()
                      : ''
                  }
                  dangerouslySetInnerHTML={{
                    __html: highlightText(
                      completeTitle,
                      this.props.textFilter,
                      'rp-highlight-background'
                    )
                  }}
                />
                {isDeal && <span className="rp-part-card--deal">On-Sale</span>}
                {part.featured && (
                  <span className="rp-part-card--featured">Featured</span>
                )}
              </div>              
            {this.renderModelDescription(t)}             
              {/* <span
              
               dangerouslySetInnerHTML={{
                __html: highlightText(
                  Replacedpart,
                  this.props.textFilter,
                  'rp-highlight-background'
                )
              }}
              className="replaced-data"
              >
                {part.replacedPart ? 'Rpl: ' + part.replacedPart : ''}
              </span> */}
              {this.renderStatus(t)}
              {this.renderPrices(t)}
            </div>
            <div className="rp-part-card--buttons desktop">
              {part.alternateProductNumber && !part.oemProductNumber ? (
                <button
                  className="viewbutton"
                  type="button"
                  // href={partDetailUrl(
                  //   `${part.alternateProductManufacturer}  ${part.alternateProductNumber}`
                  // )}
                  onClick={e => {
                    goToPartDetail(
                      `${part.alternateProductManufacturer}  ${part.alternateProductNumber}`
                    );
                  }}
                >
                  {t('myFavourites.viewnonoem')}
                </button>
              ) : (
                ''
              )}
              {part.oemProductNumber && !part.alternateProductNumber ? (
                <button
                  className="viewbutton"
                  type="button"
                  // href={partDetailUrl(
                  //   `${part.oemProductManufacturer}  ${part.oemProductNumber}`
                  // )}
                  onClick={e => {
                    goToPartDetail(
                      `${part.oemProductManufacturer}  ${part.oemProductNumber}`
                    );
                  }}
                >
                  {t('myFavourites.viewoem')}
                </button>
              ) : (
                ''
              )}

              {this.renderButtons(t)}
            </div>
          </div>
        </div>
        <div className="rp-part-card--buttons mobile mobile-visible">
          {part.alternateProductNumber && !part.oemProductNumber ? (
            <button
              className="viewbutton"
              type="button"
              // href={partDetailUrl(
              //   `${part.alternateProductManufacturer}  ${part.alternateProductNumber}`
              // )}
              onClick={e => {
                goToPartDetail(
                  `${part.alternateProductManufacturer}  ${part.alternateProductNumber}`
                );
              }}
            >
              {t('myFavourites.viewnonoem')}
            </button>
          ) : (
            ''
          )}
          {part.oemProductNumber && !part.alternateProductNumber ? (
            <button
              className="viewbutton"
              type="button"
              // href={partDetailUrl(
              //   `${part.oemProductManufacturer}  ${part.oemProductNumber}`
              // )}
              onClick={e => {
                goToPartDetail(
                  `${part.oemProductManufacturer}  ${part.oemProductNumber}`
                );
              }}
            >
              {t('myFavourites.viewoem')}
            </button>
          ) : (
            ''
          )}
          {this.renderButtons(t)}
        </div>
      </div>
    );
  };

  public render() {
    const { props } = this;

    return (
      <VisibilitySensor
        onChange={(visible: boolean) => {
          this.updateProduct(visible, props);
        }}
        intervalCheck={true}
        intervalDelay={500}
        scrollCheck={true}
        scrollDelay={250}
        delayedCall={true}
        partialVisibility={true}
        offset={200}
      >
        {this.renderContent()}
      </VisibilitySensor>
    );
  }
}

export default PartCard;
